import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../../../../../emotion-theme";

export const HostContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  padding: 8px;
  font-size: 14px;
  border-bottom: solid 1px ${BASE_COLORS.lightGrey};
`;
